import { Button, useTheme } from "@mui/material";
import React, { FC } from "react";
import { observer } from "mobx-react";

import useNotifier from "../../../hooks/useNotifier";
import { useChatStore } from "../../../hooks/useChatStore";
import { useAuth } from "../../../contexts/AuthContext";

// Grace period to let the browser act on window.close() before falling
// back to signing the user out (window.close() is a silent no-op when the
// tab wasn't opened via window.open()).
const WINDOW_CLOSE_CHECK_DELAY_MS = 200;

export const FinishChatAction: FC = observer(() => {
  const notify = useNotifier();
  const { signOut } = useAuth();
  const chatStore = useChatStore();
  const theme = useTheme();

  const handleConfirmFinish = async () => {
    try {
      window?.close();
      await new Promise((resolve) =>
        window?.setTimeout(resolve, WINDOW_CLOSE_CHECK_DELAY_MS),
      );

      if (!window?.closed) {
        await signOut();
      }
    } catch (error) {
      notify.showError(
        error instanceof Error
          ? error.message
          : "An error occurred while finishing the chat.",
      );
    }
  };

  return (
    <>
      <Button
        variant="contained"
        size="small"
        onClick={handleConfirmFinish}
        disabled={!chatStore.chatDetails?.id}
        sx={{
          alignSelf: "flex-end",
          textTransform: "none",
          width: "200px",
          margin: "auto",
          marginRight: 2,
        }}
      >
        Close & Return
      </Button>
    </>
  );
});
